import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
@Component({
  selector: 'flowaccount-certificate-partners',
  templateUrl: './certificate-partners.component.html',
  styleUrls: ['./certificate-partners.component.scss'],
})
export class CertificatePartnersComponent {
  public mockList = [
    { heading: 'Silver', pricing: '1,500.-' },
    { heading: 'Gold', pricing: '3,000.-' },
    { heading: 'Platinum', pricing: '6,000.-' },
    { heading: 'Diamond', pricing: '12,000.-' },
  ]

  constructor(public translate: TranslateService) {}

  getColor(index: number): string {
    switch (index) {
      case 0:
        return 'silver'
      case 1:
        return 'gold'
      case 2:
        return 'platinum'
      case 3:
        return 'diamond'
      default:
        return
    }
  }
}
